const STORAGE_KEY = 'ecoapps:demo-session'

const normalizeProductSlug = (value) => {
  const normalized = String(value || '').trim().toLowerCase()
  if (normalized === 'appointments') return 'agendalab'
  if (normalized === 'materialcalculator') return 'material-calculator'
  return normalized
}

const PRODUCT_CATALOG = [
  {
    id: 'demo-rentalbiz',
    name: 'RentalBiz',
    slug: 'rentalbiz',
    description: 'Gestion inmobiliaria en modo demostracion',
    category: { name: 'Inmobiliario', slug: 'inmobiliario' },
    route: '/rentalbiz/dashboard'
  },
  {
    id: 'demo-agendalab',
    name: 'AgendaLab',
    slug: 'agendalab',
    description: 'Agenda y clientes en modo demostracion',
    category: { name: 'Servicios', slug: 'servicios' },
    route: '/agendalab'
  },
  {
    id: 'demo-rentaltech',
    name: 'RentalTech LATAM',
    slug: 'rentaltech',
    description: 'Alquiler de maquinaria en modo demostracion',
    category: { name: 'Industrial', slug: 'industrial' },
    route: '/rentaltech/dashboard'
  },
  {
    id: 'demo-material-calculator',
    name: 'Material Calculator',
    slug: 'material-calculator',
    description: 'Estimacion de materiales en modo demostracion',
    category: { name: 'Construccion', slug: 'construccion' },
    route: '/material-calculator/projects'
  },
  {
    id: 'demo-brain-emprendedor',
    name: 'BrainEmprendedor LATAM',
    slug: 'brain-emprendedor',
    description: 'Salas colaborativas con IA para equipos emprendedores en modo demostracion',
    category: { name: 'Colaboracion', slug: 'colaboracion' },
    route: '/brain-emprendedor/dashboard'
  },
  {
    id: 'demo-entrepreneur-catalog',
    name: 'CatalogoEmprendedor',
    slug: 'entrepreneurcatalog',
    description: 'Catalogo publico con videos embebidos en modo demostracion',
    category: { name: 'Business', slug: 'business' },
    route: '/entrepreneurcatalog/products'
  }
]

const readStorage = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed && parsed.isDemo ? parsed : null
  } catch {
    return null
  }
}

const writeStorage = (value) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value))
  } catch {
    // no-op
  }
}

export const getDemoSession = () => readStorage()

export const isDemoMode = () => Boolean(readStorage()?.isDemo)

export const clearDemoSession = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // no-op
  }
}

export const setDemoSession = (user) => {
  const isDemo =
    Boolean(user?.isDemo) ||
    Boolean(user?.IsDemo) ||
    Boolean(user?.is_demo)

  if (!isDemo) {
    clearDemoSession()
    return
  }

  const rawProducts =
    user?.demoProducts ||
    user?.DemoProducts ||
    user?.demo_products ||
    ['rentalbiz', 'agendalab', 'rentaltech', 'material-calculator', 'brain-emprendedor', 'entrepreneurcatalog']

  const demoProducts = Array.isArray(rawProducts) && rawProducts.length > 0
    ? rawProducts.map((item) => normalizeProductSlug(item)).filter(Boolean)
    : ['rentalbiz', 'agendalab', 'rentaltech', 'material-calculator', 'brain-emprendedor', 'entrepreneurcatalog']

  writeStorage({
    isDemo: true,
    demoProduct: normalizeProductSlug(user?.demoProduct || user?.DemoProduct || user?.demo_product || ''),
    demoProducts,
    updatedAt: Date.now()
  })
}

export const getDemoProducts = () => {
  const session = readStorage()
  if (!session?.isDemo) return []

  const allowed = new Set((session.demoProducts || []).map((item) => normalizeProductSlug(item)))
  return PRODUCT_CATALOG.filter((product) => allowed.has(product.slug))
}

export const isDemoUser = (user) =>
  Boolean(user?.isDemo) || Boolean(user?.IsDemo) || Boolean(user?.is_demo)

export const getLogoutRedirectPath = (_user, _pathname = '') => '/'
